<template>
  <button class="clothing__option-button">
    <Icon id="arrow_head" class="--icon" />
    <Icon id="clothing_toggle" class="--background" />
  </button>
</template>

<script>
import { Icon } from '@/components/global'

export default {
  name: 'ClothingToggleButton',
  components: { Icon },
}
</script>
